import { Controller } from 'react-hook-form'
import classNames from 'classnames'
import { DatePicker } from 'rsuite'
import moment from 'moment'
import { LOCAL_DAY_TH } from '../../constants/date'
import { dateMonst2 } from '../../utils/dataUtil'
import DatePickerCustom from '../datePicker/DatePickerCustom'

export default function EditDateCustomCell({
  id,
  rowData,
  dataKey,
  register,
  control,
  errors,
  startDate,
  endDate,
  defaultDate,
  isEdit,
  onChangeCell = () => {},
  ...props
}) {
  const editing = rowData.status === 'EDIT' || isEdit
  const _id = id || rowData.id

  return (
    <>
      <span {...props} className={editing ? 'table-content-editing' : ''}>
        {editing ? (
          <>
            {startDate && endDate ? (
              <Controller
                name={id || rowData.id}
                control={control}
                defaultValue={
                  defaultDate ||
                  (rowData[dataKey]
                    ? moment(rowData[dataKey], 'DD/MM/YYYY').toDate()
                    : moment().startOf('day').toDate())
                }
                rules={{ required: 'กรุณากรอกกำหนดส่งผลงาน' }}
                render={(props) => {
                  return (
                    <DatePickerCustom
                      {...props}
                      className={classNames(errors[_id] && 'is-error')}
                      onChange={(value) => {
                        props.onChange(value)
                        onChangeCell(value)
                      }}
                      placement="auto"
                      disabledDate={(date) => dateMonst2(date, startDate, endDate)}
                    />
                    // <DatePicker
                    //   className={classNames(errors[_id] && 'is-error')}
                    //   format="DD/MM/YYYY"
                    //   locale={LOCAL_DAY_TH}
                    //   block
                    //   oneTap
                    //   placement="auto"
                    //   value={props.value}
                    //   onChange={(value) => {
                    //     props.onChange(value)
                    //     onChangeCell(value)
                    //   }}
                    //   disabledDate={(date) => dateMonst2(date, startDate, endDate)}
                    // />
                  )
                }}
              />
            ) : (
              <Controller
                name={id || rowData.id}
                control={control}
                defaultValue={
                  rowData[dataKey]
                    ? moment(rowData[dataKey], 'DD/MM/YYYY').toDate()
                    : moment().startOf('day').toDate()
                }
                rules={{ required: 'กรุณากรอกกำหนดส่งผลงาน' }}
                render={(props) => {
                  return (
                    <DatePickerCustom
                      {...props}
                      className={classNames(errors[_id] && 'is-error')}
                      onChange={(value) => {
                        props.onChange(value)
                        onChangeCell(value)
                      }}
                      placement="auto"
                    />
                    // <DatePicker
                    //   className={classNames(errors[_id] && 'is-error')}
                    //   format="DD/MM/YYYY"
                    //   locale={LOCAL_DAY_TH}
                    //   block
                    //   oneTap
                    //   placement="auto"
                    //   value={props.value}
                    //   onChange={(value) => {
                    //     props.onChange(value)
                    //     onChangeCell(value)
                    //   }}
                    // />
                  )
                }}
              />
            )}
          </>
        ) : (
          <span>{rowData[dataKey]}</span>
        )}
      </span>
    </>
  )
}
